<template>
  <div v-if="subscription.id">
    <div class="flex flex-wrap justify-between mb-4">
      <div class="flex-inline">&nbsp;</div>
      <div class="flex align-items-end">
        <vs-button class="mr-4" icon-pack="feather" icon="icon icon-arrow-left" @click="back">Voltar</vs-button>
        <vs-button icon-pack="feather" icon="icon icon-file" @click="print">Imprimir</vs-button>
      </div>
    </div>

    <div class="flex">
      <div id="invoice-page" class="w-full mb-base mr-4">
        <vx-card id="invoice-container">
          <!-- INVOICE METADATA -->
          <div class="vx-row leading-loose p-base">
            <div class="vx-col w-1/2 mt-base">
              <img :src="`/assets/images/logo/logo_${appFilename}.png`" alt="" />
            </div>
            <div class="vx-col w-1/2 text-right">
              <h1
                :class="{
            'text-success': subscription.status == 'Ativa' || subscription.status == 'Aprovada',
            'text-warning': subscription.status == 'Aguardando Pagamento' || subscription.status == 'Aguardando Aprovação',
            'text-danger': subscription.status.indexOf('Cancelada') > -1
          }"
              >{{subscription.status}}</h1>

              <div class="invoice__invoice-detail mt-6">
                <h3>{{subscription.number}}</h3>
                <p>{{subscription.created_at | formatDateTime}}</p>
              </div>
            </div>
            <div class="vx-col w-1/2 mt-12">
              <div class="invoice__recipient-info my-4">
                <p v-if="subscription.user">{{subscription.user.name}}</p>
                <p v-if="subscription.user">
                  <router-link :to="{ name: 'cliente-detalhes', params: { id: subscription.user.id } }">{{subscription.user.email}}</router-link>
                </p>
                <p v-if="subscription.user">{{subscription.user.cpfcnpj}}</p>
                <p v-if="subscription.user">
                  {{subscription.user.address_street}}
                  {{subscription.user.address_number}}
                </p>
                <p v-if="subscription.user">{{subscription.user.address_postcode}}</p>
                <p v-if="subscription.user">{{subscription.user.address_city}}</p>
                <p v-if="subscription.user">{{subscription.user.address_state}}</p>
              </div>
            </div>
            <div class="vx-col w-1/2 mt-base text-right mt-12">
              <div class="invoice__company-info my-4">
                <p>
                  <a
                    :href="`https://www.paypal.com/billing/subscriptions/${subscription.paypal_subscription_id}`"
                    v-if="subscription.paypal_subscription_id"
                    target="_blank"
                  >Ver Assinatura no PayPal</a>

                  <a :href="`https://dashboard.stripe.com/subscriptions/${subscription.stripe_subscription_id}`" target="_blank" v-if="subscription.stripe_subscription_id">
                    Ver Assinatura no Stripe
                  </a>
                </p>
              </div>
            </div>
          </div>

          <div class="p-base">
            <vs-table :stripe="true" :data="subscription.licences" class="mt-4" v-if="subscription.licences.length">
              <template slot="header">
                <h3 class="p-2">Histórico</h3>
              </template>

              <!-- HEADER -->
              <template slot="thead">
                <vs-th class="pointer-events-none">ID</vs-th>
                <vs-th class="pointer-events-none">DATA DE CRIAÇÃO</vs-th>
                <vs-th class="pointer-events-none">DATA DE USO</vs-th>
                <vs-th class="pointer-events-none">ID DISPOSITIVO</vs-th>
                <vs-th class="pointer-events-none">MESES</vs-th>
                <vs-th class="pointer-events-none">VENDA</vs-th>
              </template>

              <!-- DATA -->
              <template>
                <vs-tr v-for="licence in subscription.licences" :key="licence.id">
                  <vs-td>{{licence.id}}</vs-td>
                  <vs-td>{{licence.date_added | formatDateTime}}</vs-td>
                  <vs-td>{{licence.date_used | formatDateTime}}</vs-td>
                  <vs-td>{{licence.device_id}}</vs-td>
                  <vs-td>{{licence.months}}</vs-td>
                  <vs-td>
                    <router-link :to="{ name: 'venda-detalhes', params: { id: licence.order_id } }">{{licence.order_id}}</router-link>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>

          <div class="p-base">
            <vs-table :stripe="true" :data="subscription.history" class="mt-4" v-if="subscription.history.length">
              <template slot="header">
                <h3 class="p-2">Histórico</h3>
              </template>

              <!-- HEADER -->
              <template slot="thead">
                <vs-th class="pointer-events-none">ID</vs-th>
                <vs-th class="pointer-events-none">DATA</vs-th>
                <vs-th class="pointer-events-none">ID DA TRANSAÇÃO</vs-th>
                <vs-th class="pointer-events-none">EVENTO</vs-th>
              </template>

              <!-- DATA -->
              <template>
                <vs-tr v-for="history in subscription.history" :key="history.id">
                  <vs-td>{{history.id}}</vs-td>
                  <vs-td>{{history.created_at | formatDateTime}}</vs-td>
                  <vs-td>{{history.transaction_id || '-'}}</vs-td>
                  <vs-td>{{history.status || '-'}}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      subscription: {
        user: {},
        plan: {},
        order: {},
        licences: [],
        history: []
      },
      refundOrderConfirm: false,
      approveOrderConfirm: false,
      refund: {
        amount: '',
        comment: ''
      },
      appFilename: process.env.VUE_APP_FILENAME,
    };
  },
  mounted() {
    this.$emit('setAppClasses', 'invoice-page');

    this.$api
      .get(`/api/v1/backend/subscription/${this.$route.params.id}`)
      .then((response) => {
        this.subscription = response.data;
      });
  },
  methods: {
    print() {
      window.print();
    },
    back() {
      window.history.back();
    },
    approveOrder() {
      this.$vs.loading();

      this.$api
        .patch(`/api/v1/backend/subscription/${this.$route.params.id}/paid`)
        .then(response => {
          this.$vs.loading.close();
          this.subscription = response.data;
        })
        .catch(err => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: 'Erro',
            text: err.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    }
  }
};
</script>

<style lang="scss">
@media print {
  .invoice-page {
    * {
      visibility: hidden;
    }

    #content-area {
      margin: 0 !important;
    }

    .vs-con-table {
      .vs-con-tbody {
        overflow: hidden !important;
      }
    }

    #invoice-container,
    #invoice-container * {
      visibility: visible;
    }
    #invoice-container {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}

@page {
  size: auto;
}

.vs-con-table {
  .vs-table--thead {
    th {
      .vs-table-text {
        display: inline-block;
      }
    }
  }
}
</style>
